import { getTreatment } from '@eventbrite/splitio-client';

export type SplitKey = Parameters<typeof getTreatment>[0];

/**
 * This key is used to get the treatment for the homepage-webapp instead of userId, to avoid
 * contributing to our limited monthly total keys.
 *
 * https://eventbrite.atlassian.net/wiki/x/fwBb4QM
 */
export const HOMEPAGE_WEBAPP_KEY: SplitKey = 'homepage-webapp';
